import { z } from "zod";

/**
 * Profil LinkedIn normalisé — format INTERNE stable, indépendant des
 * fournisseurs (Bright Data, PDL plus tard). C'est ce que l'utilisateur
 * prévisualise avant création du CV.
 */
export const LinkedInProfileDraftSchema = z.object({
  name: z.string().optional(),
  headline: z.string().optional(),
  about: z.string().optional(),
  location: z.string().optional(),
  avatar: z.string().url().optional(),
  experiences: z
    .array(
      z.object({
        title: z.string().optional(),
        company: z.string().optional(),
        location: z.string().optional(),
        start: z.string().optional(),
        end: z.string().optional(),
        description: z.string().optional(),
      }),
    )
    .default([]),
  educations: z
    .array(
      z.object({
        degree: z.string().optional(),
        school: z.string().optional(),
        start: z.string().optional(),
        end: z.string().optional(),
      }),
    )
    .default([]),
  certifications: z
    .array(
      z.object({
        name: z.string().optional(),
        issuer: z.string().optional(),
        date: z.string().optional(),
        url: z.string().optional(),
      }),
    )
    .default([]),
  skills: z.array(z.string()).default([]),
  languages: z.array(z.string()).default([]),
});

export type LinkedInProfileDraft = z.infer<typeof LinkedInProfileDraftSchema>;

/** Compteur de sections remplies — affiché dans la prévisualisation. */
export const draftSectionSummary = (draft: LinkedInProfileDraft) => ({
  name: Boolean(draft.name),
  experiences: draft.experiences.length,
  educations: draft.educations.length,
  certifications: draft.certifications.length,
  skills: draft.skills.length,
  languages: draft.languages.length,
  about: Boolean(draft.about),
});
